import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Obrigado, {{name}}',
    confirmation_email:
      'Receberá em breve um e-mail de confirmação com o número da sua encomenda pelo nosso Parceiro Tecnológico {{provider_email}}',
    need_help: 'Precisa de ajuda?',
  },
  labels: {
    order_number: 'Encomenda Nº: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Hoje',
    was_prefix: 'era',
    restaurant: 'Restaurante',
    order_details: 'Detalhes da encomenda',
    your_details: 'Os seus dados',
    contact: 'Contacto',
    payment: 'Pagamento',
    payment_method: 'Método de pagamento',
    delivery: 'Entrega',
    delivery_details: 'Detalhes de entrega',
    pickup_details: 'Detalhes de takeaway',
    pickup_instruction: '📋 Indique o número de encomenda {{number}} quando levantar a sua encomenda.',
    billing_info: 'Informação de faturação',
    order_note: 'Nota do pedido',
    order_summary: 'Resumo da encomenda',
    help: 'Precisa de ajuda? Contacte-nos {{phone_number}}',
  },
  status: {
    canceled: 'Encomenda cancelada',
    received: 'Encomenda recebida',
    confirmed: 'Encomenda confirmada!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Takeaway',
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.ON_SITE]: 'Pedido à mesa',
  },
  rewards: {
    member: {
      pill_title: 'Pontos ganhos',
      from_order: 'pontos desta encomenda',
      total_balance: 'Saldo total',
      reward_value: 'Valor da recompensa',
      redeem_hint: '✓ Pode resgatar até {{points}} pts ({{amount}}) na sua próxima encomenda',
      points_to_redeem: 'Precisa apenas de mais {{points}} pontos para resgatar a sua recompensa',
    },
    guest: {
      pill_title: 'Recompensas',
      earned_heading: 'Ganhou <highlight>{{points}} pontos</highlight> nesta encomenda',
      worth_on_next: 'Vale <strong>{{amount}}</strong> na sua próxima encomenda',
      ready_to_claim: 'Pronto a reclamar',
      next_order_discount: 'Desconto na próxima encomenda',
      claim_cta: 'Resgate os seus {{points}} pts — registe-se gratuitamente',
      claim_note: 'Demora 30 segundos · os seus pontos são creditados de imediato',
    },
  },
  buttons: {
    back_to_menu: 'Voltar ao menu',
    back_to_checkout: 'Voltar ao pagamento',
    contact_us: 'Contacte-nos {{phone_number}}',
    try_again: 'Tentar novamente',
  },
  loading: {
    processing_payment: 'Por favor, não abandone a página enquanto processamos o seu pagamento',
  },
  success_messages: {
    order_placed: {
      title: '✅ Encomenda efetuada com sucesso!',
      description: 'A sua encomenda foi efetuada com sucesso.',
    },
  },
  error_messages: {
    failed_to_load: 'Não foi possível carregar a encomenda. Por favor, tente novamente.',
    payment_failed: 'Pagamento falhado, por favor tente novamente',
  },
  load_failed: {
    title: 'Não foi possível carregar o teu pedido',
    description:
      'Ocorreu um erro ao carregar os detalhes da tua encomenda. Tenta novamente. Se continuar a acontecer, contacta o suporte e ajudamos-te de imediato.',
  },
};
